import { BrowserRouter, Routes, Route } from 'react-router';
import { AuthProvider } from '@podus/auth';
import { authConfig } from './auth-config';
import { LanguageProvider } from '@/i18n/LanguageContext';
import Home from './pages/Home';
import DocumentPage from './pages/Document';
import Blog from './pages/Blog';
import BlogPost from './pages/Blog/Post';
import Referral from './pages/Referral';
import NotFound from './pages/NotFound';

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider config={authConfig}>
                <LanguageProvider>
                    <Routes>
                        <Route index element={<Home />} />
                        <Route path="blog" element={<Blog />} />
                        <Route path="blog/:slug" element={<BlogPost />} />
                        <Route path="public/document/:documentId" element={<DocumentPage />} />
                        {/* Ambassador referral links — resolves the code, then hands off to auth. */}
                        <Route path="ab/:code" element={<Referral />} />
                        {/* Catch-all: without this, unknown URLs rendered a blank 200 page. */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </LanguageProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
